// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socialEntranceButton_button__39llD {\n  width: 90px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  cursor: pointer;\n}\n.socialEntranceButton_button__39llD:hover {\n  box-shadow: 1px 3px 4px 0px var(--black-10);\n}", ""]);
// Exports
exports.locals = {
	"button": "socialEntranceButton_button__39llD"
};
module.exports = exports;
